import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const Services = () => {
  return (
    <div className="pt-10 pb-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h1 className="text-5xl font-serif font-bold text-navy-900 mb-6">World-Class Solutions.</h1>
          <p className="text-xl text-slate-600 leading-relaxed">
            Tailored interventions for every tier of your organisation. From strategic boardroom guidance to frontline empowerment.
          </p>
        </div>

        <div className="space-y-24">
          {/* Service 1: Consulting */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-100 text-navy-900 text-sm font-bold mb-6 uppercase tracking-wider">
                For Senior Leaders
              </div>
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 mb-6">Strategic Consulting</h2>
              <p className="text-lg text-slate-600 mb-6 leading-relaxed">
                Partner with us to build a resilient, 'Outstanding' organisation. We cut through the noise to provide actionable strategies that align compliance, operations, and financial growth.
              </p>
              <ul className="space-y-4 mb-8">
                <li className="flex items-start gap-3">
                  <span className="mt-1 bg-gold-500/20 p-1 rounded text-gold-600"><SafeIcon name="Activity" className="w-4 h-4" /></span>
                  <span className="text-slate-700"><strong>CQC Turnaround:</strong> Diagnostic reviews and mock inspections.</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-1 bg-gold-500/20 p-1 rounded text-gold-600"><SafeIcon name="Shield" className="w-4 h-4" /></span>
                  <span className="text-slate-700"><strong>Quality Systems:</strong> Implementing the Kajidori Combined Operating System.</span>
                </li>
              </ul>
              <Link to="/contact?type=general" className="inline-block bg-navy-900 text-white px-8 py-4 rounded-lg font-bold hover:bg-navy-800 transition-all shadow-xl">
                Apply for Strategic Consulting
              </Link>
            </div>
            <div className="order-1 lg:order-2">
              <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Consulting" className="rounded-xl shadow-2xl" />
            </div>
          </div>

          <hr className="border-slate-200" />

          {/* Service 2: Training */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img src="https://images.unsplash.com/photo-1544928147-79a2dbc1f389?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Training" className="rounded-xl shadow-2xl" />
            </div>
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gold-500/10 text-gold-600 text-sm font-bold mb-6 uppercase tracking-wider border border-gold-500/20">
                Flagship Programme
              </div>
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 mb-6">Mental Health & Complex Needs Excellence</h2>
              <p className="text-lg text-slate-600 mb-6 leading-relaxed">
                Transform your frontline teams and middle management. Deep-dive, practical programme designed to improve outcomes and staff retention.
              </p>
              <ul className="space-y-4 mb-8">
                <li className="flex items-start gap-3">
                  <span className="mt-1 bg-navy-100 p-1 rounded text-navy-700"><SafeIcon name="Users" className="w-4 h-4" /></span>
                  <span className="text-slate-700"><strong>Portal Integration:</strong> Includes full access to The Kajidori Portal for digital certificates.</span>
                </li>
              </ul>
              <Link to="/contact?type=training" className="inline-block bg-navy-900 text-white px-8 py-4 rounded-lg font-bold hover:bg-navy-800 transition-all shadow-xl">
                Apply for This Programme
              </Link>
            </div>
          </div>

          <hr className="border-slate-200" />

          {/* Service 3: Mentoring */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-100 text-navy-900 text-sm font-bold mb-6 uppercase tracking-wider">
                High-Ticket Offering
              </div>
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 mb-6">Leadership Mentoring</h2>
              <p className="text-lg text-slate-600 mb-6 leading-relaxed">
                Confidential, strategic sounding-board support for CEOs and Registered Managers navigating complex operational challenges.
              </p>
              <Link to="/contact?type=mentoring" className="inline-block bg-navy-900 text-white px-8 py-4 rounded-lg font-bold hover:bg-navy-800 transition-all shadow-xl">
                Apply for Mentoring
              </Link>
            </div>
            <div className="order-1 lg:order-2 bg-navy-900 rounded-xl p-12 text-center text-white relative overflow-hidden">
              <div className="absolute top-0 right-0 w-64 h-64 bg-gold-500/10 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2"></div>
              <SafeIcon name="Award" className="w-16 h-16 text-gold-500 mx-auto mb-6 relative z-10" />
              <h3 className="text-2xl font-serif font-bold mb-4 relative z-10">Ready to Transform Your Leadership?</h3>
              <p className="text-slate-300 mb-8 relative z-10">Applications for private mentoring are strictly limited to ensure highest quality support.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;